<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DHExLo/tc-custom/9781446362778.jpg?1700306265456" alt="This image is the cover for the book Knotting & Braiding Bible"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knotting & Braiding Bible
      </h1>
      <p class="bookDescription body article font2">
        <b>The most comprehensive guide to knotting and braiding techniques, with hundreds of illustrations for making jewelry, accessories, and decorative items.</b><br/><br/>Ideal for everyone from experienced makers and young people making their first friendship bracelet, this guide from bestselling author Dorothy Wood shows you how to master hundreds of knotting and braiding techniques to create stunning jewelry, accessories, and home decorations.<br/><br/>Techniques cover kumihimo (braiding), plaiting, knotting (including macrame), and fusion, as well as adding beads, using different cords/wire, and attaching findings.<br/><br/>Easy to follow step-by-step instruction and photography will help you to learn each of the different techniques—and you can choose from a selection of project ideas to refine your new skills to create beautiful items for yourself and others.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Wood
      </h2>
      
      <p class="authorDescription body article"><P><B>Dorothy Wood</B> is an expert beader, craft designer and author who has written over 20 craft books on a variety of subjects and is a regular contributor to numerous craft magazines. Her recent titles for David & Charles include the bestselling <I>The Beader's Bible</I> (2008), <I>Crystal Jewellery Creations</I> (2010), and <I>The Bead Jewellery Bible</I> (2011). In 2012 Dorothy became the first UK Ambassador for Swarovski Elements.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c2edc084